// Monta objetos no mesmo formato usado pela Ficha da Fiscalização (AutoDeFiscalizacao) e pela
// Ficha do Auto de Infração (FichaInfracao/CabecalhoInfracao) a partir dos dados ainda em memória
// (execucaoFiscalizacao), para a tela de Prévia reaproveitar exatamente os mesmos componentes/layout
// usados após a gravação — sem número de processo/infração, que ainda não existem.

function montarEnderecoCompleto({ logradouro, numeroLogradouro, bairro, cidade, uf }) {
  const enderecoENumero = [logradouro, numeroLogradouro].filter(Boolean).join(", ");
  const cidadeEUf = [cidade, uf].filter(Boolean).join("/");
  return [enderecoENumero, bairro, cidadeEUf].filter(Boolean).join(" - ");
}

// Mesmo mapeamento usado em FormularioFiscalizacao.jsx para montar o link de download do anexo.
const MIME_POR_EXTENSAO = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  pdf: "application/pdf",
};

function montarAnexoDataUri(anexo) {
  if (!anexo?.arquivoBase64) return null;
  const extensao = (anexo.extensao || "jpeg").toLowerCase();
  return `data:${MIME_POR_EXTENSAO[extensao] || "image/jpeg"};base64,${anexo.arquivoBase64}`;
}

function montarInfratorPreview(execucaoFiscalizacao) {
  const infrator = execucaoFiscalizacao.infrator || {};
  return {
    nome: infrator.nomeRazao,
    fantasia: infrator.nomeFantasia,
    documentoIdentificacao: infrator.documentoIdentificacao,
    email: infrator.email,
    codigoCadastro: infrator.codigoCadastro,
    emailsCC: execucaoFiscalizacao.emailsCC || [],
    cep: infrator.cep_Infrator,
    logradouro: infrator.logradouro_Infrator,
    bairro: infrator.bairro_Infrator,
    numero: infrator.numeroLogradouro_Infrator,
    complemento: infrator.complemento_Infrator,
    cidade: infrator.cidade_Infrator,
    uf: infrator.uf_Infrator,
    assinaturaInfrator: execucaoFiscalizacao.assinaturaInfratorBase64 || null,
  };
}

// Ficha da Fiscalização (mesmo formato consumido por src/views/Shared/AutoDeFiscalizacao).
export function montarFichaFiscalizacaoPreview({
  execucaoFiscalizacao,
  tipoFiscalizacao,
  formulario,
  infracoes,
  solicitacaoImages,
}) {
  return {
    tipoFiscalizacao_Identificacao: execucaoFiscalizacao.tipoFiscalizacaoIdentificacao,
    enderecoCompleto: montarEnderecoCompleto(execucaoFiscalizacao),
    dataFlagrande: execucaoFiscalizacao.dataFiscalizacao,
    dataFiscalizacao: execucaoFiscalizacao.dataFiscalizacao,
    codigoItem: execucaoFiscalizacao.codigoItemFiscalizado,
    infrator: montarInfratorPreview(execucaoFiscalizacao),
    assinaturaInfrator: execucaoFiscalizacao.assinaturaInfratorBase64 || null,
    anexosSolicitacoes: (solicitacaoImages || []).map((imagem) => ({ anexo: imagem.nomeArquivo })),
    formulario: (execucaoFiscalizacao.formulario || [])
      .filter((resposta) => !!resposta.valor)
      .map((resposta) => {
        const questao = formulario?.formularioQuestoes?.find(
          (value) => value.id == resposta.formularioQuestao_Id
        );
        return {
          questao: questao?.questao ?? "",
          resposta: resposta.valor,
          // TabelaListagemFichas espera um objeto { anexo, nomeArquivoOriginal } por anexo (CE-3786),
          // não a string de data URI usada por montarAnexoDataUri/anexoQuestao.
          anexos: (resposta.anexos || [])
            .map((anexo) => {
              const dataUri = montarAnexoDataUri(anexo);
              return dataUri ? { anexo: dataUri, nomeArquivoOriginal: anexo.nomeArquivoOriginal } : null;
            })
            .filter(Boolean),
        };
      }),
    infracoes: (infracoes || []).map((infracao) => ({
      infracao_Identificacao: infracao.infracao_Identificacao,
      tipoInfracao: infracao.tipoInfracao,
    })),
  };
}

// Ficha do Auto de Infração (mesmo formato consumido por src/views/Shared/FichaInfracao), uma por
// infração prevista retornada pela API — correlacionada à resposta de origem via FormularioQuestao_Id.
export function montarFichaInfracaoPreview({
  execucaoFiscalizacao,
  tipoFiscalizacao,
  infracaoPreview,
}) {
  const tipoFiscalizacaoServico = tipoFiscalizacao?.tipoFiscalizacaoServicos?.find(
    (servico) => servico.id == execucaoFiscalizacao.tipoFiscalizacaoServico_Id
  );
  const respostaOrigem = (execucaoFiscalizacao.formulario || []).find(
    (resposta) => resposta.formularioQuestao_Id == infracaoPreview.formularioQuestao_Id
  );

  return {
    tipoFiscalizacao_Identificacao: execucaoFiscalizacao.tipoFiscalizacaoIdentificacao,
    tipoFiscalizacaoServico_Identificacao: tipoFiscalizacaoServico?.identificacao,
    dataInfracao: execucaoFiscalizacao.dataFiscalizacao,
    dataFlagrande: execucaoFiscalizacao.dataFiscalizacao,
    enderecoCompleto: montarEnderecoCompleto(execucaoFiscalizacao),
    fiscalizacaoItem_Codigo: execucaoFiscalizacao.codigoItemFiscalizado,
    infracao_Identificacao: infracaoPreview.infracao_Identificacao,
    infracao_Clausula: infracaoPreview.clausula,
    tipoInfracao: infracaoPreview.tipoInfracao,
    valor: infracaoPreview.valorInfracao,
    infrator: montarInfratorPreview(execucaoFiscalizacao),
    anexoQuestao: montarAnexoDataUri(respostaOrigem?.anexos?.[0]),
  };
}
